import { render, staticRenderFns } from "./uomValue.vue?vue&type=template&id=19ec7ed7&"
import script from "./uomValue.vue?vue&type=script&lang=js&"
export * from "./uomValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports